import * as React from "react";
import { CalcRequestItem } from "../../../../../application/domain/payment/calc-request";
import { LinkButton } from "../../../../atoms/link-button";
import { CalcRequestItemValidator } from "../../../../../application/domain/payment/calc-request-item-validator";
import { useState } from "react";
import { TaxRateLiterals } from "@graffer-inc/cloud-gov-core";

export const PaymentItemLine: React.FC<{
  item: CalcRequestItem;
  onChange: (item: CalcRequestItem) => void;
  onDelete: () => void;
}> = ({ item, onChange, onDelete }) => {
  const errors = new CalcRequestItemValidator(item).validate();
  const [touched, setTouched] = useState<{ [key: string]: boolean }>({});

  return (
    <>
      <tr>
        <td>
          <div className="field has-addons">
            <p className="control">
              <input
                className="input"
                value={item.description}
                onBlur={() => setTouched({ ...touched, description: true })}
                onChange={(e) => {
                  onChange({ ...item, description: e.target.value });
                }}
              />
              {errors.description && touched.description && (
                <p className="help is-danger">{errors.description}</p>
              )}
            </p>
          </div>
        </td>
        <td>
          <>
            <div className="field has-addons">
              <p className="control">
                <input
                  className="input"
                  value={item.amount}
                  style={{
                    maxWidth: "100px",
                  }}
                  onBlur={() => setTouched({ ...touched, amount: true })}
                  onChange={(e) => {
                    onChange({ ...item, amount: parseInt(e.target.value, 10) });
                  }}
                />
              </p>
              <p className="control">
                <LinkButton className="button is-static">円</LinkButton>
              </p>
            </div>
            {errors.amount && touched.amount && (
              <p className="help is-danger">{errors.amount}</p>
            )}
          </>
        </td>
        <td>
          <div className="select">
            <select
              onChange={(e) => {
                onChange({
                  ...item,
                  taxRate: e.target.value as TaxRateLiterals,
                });
              }}
            >
              <option selected={item.taxRate === "0"} value="0">
                非課税
              </option>
              <option selected={item.taxRate === "0.08"} value="0.08">
                8%
              </option>
              <option selected={item.taxRate === "0.1"} value="0.1">
                10%
              </option>
            </select>
          </div>
        </td>
        <td>
          <LinkButton className="delete is-large" onClick={onDelete} />
        </td>
      </tr>
    </>
  );
};
